import React from 'react'

const ClosedButton = () => {
  return (
    <div>
        <button className='bg-white text-black font-semibold cursor border py-3 px-8 rounded-md'>
            Closed
        </button>
    </div>
  )
}

export default ClosedButton